export enum ScreenSizes {
    XSmall = 375,
    XSmall2 = 430,
    Small = 640,
    Medium = 768,
    Large = 1024,
    XLarge = 1280,
    XXLarge = 1536,
}